import { useMemo } from 'react';

import { StyledAnimatedText } from './styles';
import { useTextAnimation } from './useTextAnimation';

export type AnimatedTextVariant = 'heading' | 'subtext' | 'emailAgent';

export type AnimatedTextProps = {
  texts: string[];
  speedFactor?: number;
  variant?: AnimatedTextVariant;
};

export const AnimatedText = ({ texts, speedFactor = 1, variant = 'heading' }: AnimatedTextProps) => {
  const animatedTextElRef = useTextAnimation({ texts, speedFactor });

  const displayText = useMemo(() => texts[0] || '', [texts]);

  return (
    <StyledAnimatedText ref={animatedTextElRef} $variant={variant} data-automation="AnimatedText">
      {displayText}
    </StyledAnimatedText>
  );
};
